import api from './axios';

const projectApi = {
  getProjects: (params) => {
    return api.get('/projects', { params });
  },

  getProject: (id) => {
    return api.get(`/projects/${id}`);
  },

  createProject: (data) => {
    return api.post('/projects', data);
  },

  updateProject: (id, data) => {
    return api.put(`/projects/${id}`, data);
  },

  deleteProject: (id) => {
    return api.delete(`/projects/${id}`);
  }
};

export default projectApi;
